import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Swiper from "swiper/bundle";
window.Swiper = Swiper;

import Choices from "choices.js"
window.Choices = Choices


// swiper
const swiper = new Swiper('.swiper', {
	direction: 'horizontal',
	speed: 800,
	spaceBetween: 8,
	slidesPerView: "auto",

	// autoplay: {
	// 	delay: 8000,
	// },

	pagination: {
		el: '.swiper-pagination',
	},

	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	// scrollbar: {
	// 	el: '.swiper-scrollbar',
	// },

	grabCursor: false,

	allowTouchMove: false,

	// effect: 'fade',
	// fadeEffect: {
	// 	crossFade: true
	// },
});

// Acc
if (document.querySelector('.js-acc')) {
	const acc = document.querySelectorAll('.js-acc')
	acc[0].children[1].style.display = 'block'

	acc.forEach(e => {
		e.addEventListener('click', () => {
			accOpen(e)
		})
	})

	function accOpen(e) {
		acc.forEach(item => {
			item.children[1].style.display = 'none'
		})

		e.children[1].style.display = 'block'
	}
}
